import { Link } from 'react-router';
import type { TLocalize } from '@hooks/use-localize';
import type { ILabOrdersModel } from '@/types/history/lab-orders';

interface IProps {
    model: ILabOrdersModel;
    t: TLocalize;
}

/** Lab orders have been requested but the scrip isn't back yet. */
const OrdersPendingSection = ({ model, t }: IProps) => (
    <>
        <h1>{t('DashLabel_LabOrdersRequested', 'Lab Orders Requested')}</h1>

        <div className="well well-sm">
            <p>
                {t('DashLabel_WeVeInitiatedTheRequestForYourLabOrders', "We've initiated the request for your lab orders.")}
            </p>
            <p>
                {t('DashLabel_YourRequisitionNumberIs', 'Your requisition number is')}:{' '}
                <strong>{model.requisitionNumber}</strong>
            </p>
            <p>
                {t('DashLabel_OnceADoctorApprovesTheLabOrders(Usually36Hours)YouLlBeRea', 'You will receive an email when your lab orders are ready.')}
            </p>

            {model.isPhlebot && (
                <p>
                    {t('DashLabel_PhlebotomistContactDetails', 'The phlebotomist will contact you to schedule your appointment after the labs are approved.')}
                </p>
            )}
        </div>

        <p>
            <Link
                className="btn btn-primary"
                to={'/register/donate/' + model.id + '/' + model.editKey}
            >
                {t('DashLabel_BackToDashboard', 'Back to Dashboard')}
            </Link>
        </p>
    </>
);

export default OrdersPendingSection;
